import CommentIcon from "@mui/icons-material/Comment";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import ConstructionIcon from "@mui/icons-material/Construction";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import { GiTemporaryShield } from "react-icons/gi";
import PropTypes from "prop-types";
import { DeleteIcon } from "./ActionIcons";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import { VehicleIcon } from "./VehicleIcon";
import { WarningIcon } from "./ResultIcons";

export function KommenttiIcon({ ...props }) {
  return <CommentIcon {...props} />;
}

export function PoisAjostaIcon({ ...props }) {
  return <EventBusyIcon {...props} />;
}

export function HuoltoIcon({ ...props }) {
  return <ConstructionIcon {...props} />;
}

export function PrivateIcon({ ...props }) {
  return <PrivacyTipIcon {...props} />;
}

export function TempIcon({ ...props }) {
  return <GiTemporaryShield {...props} />;
}

export function PalkkiIcon({ palkki, ...props }) {
  if (palkki === false) return null;
  const t = palkki?.grid_palkkiTypeId;
  if (t === 2) return <PoisAjostaIcon color="warning" {...props} />;
  if (t === 4) return <KommenttiIcon color="primary" {...props} />;
  if (t === 5) return <HuoltoIcon color="primary" {...props} />;
  if (t === 8) return <PrivateIcon color="primary" {...props} />;
  if (t === 9) return <TempIcon color="primary" {...props} />;
  if (t === 11) return <DeleteIcon color="error" {...props} />;
  if (t === 12) return <TyöIcon color="primary" {...props} />;
  if (t === 13) return <MoreInfoIcon color="primary" {...props} />;
  if (t === 14) return <VehicleIcon color="primary" {...props} />;
  if (t === 15) return <WarningIcon color="warning" {...props} />;
  return null;
}
PalkkiIcon.propTypes = {
  palkki: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
};

export function TyöIcon({ ...props }) {
  return <AssignmentIndIcon {...props} />;
}

export function MoreInfoIcon({ ...props }) {
  return <ReadMoreIcon {...props} />;
}
